// src/components/FullScreenRecipeView.tsx
import React from 'react';
import { Recipe } from '../../api/Recipe';
import useDismissibleOverlay from '../../hooks/ui/useDismissibleOverlay';
import { Box, Button, Flex } from '../ui';
import RecipeTextSections from './RecipeTextSections';
import RecipeTitleBlock from './RecipeTitleBlock';

interface FullScreenRecipeViewProps {
  recipe: Recipe;
  onClose: () => void;
}

const FullScreenRecipeView: React.FunctionComponent<FullScreenRecipeViewProps> = ({ recipe, onClose }) => {
  useDismissibleOverlay({
    isOpen: true,
    onClose,
  });
  
  return (
    <Box
      className="fullscreen-overlay" 
      data-testid="fullscreen-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="recipe-title"
    >
      <Flex direction="column" className="fullscreen-content" data-testid="fullscreen-content">
        <Box
          id="recipe-print-area"
          className="recipe-content-area"
          flexGrow
          overflowY="auto"
          style={{ padding: '0 2rem', paddingBottom: '120px' }}
        >
          <RecipeTitleBlock
            recipe={recipe}
            titleId="recipe-title"
            titleLayout={{ textAlign: 'center', marginY: 4 }}
            authorLayout={{ textAlign: 'center', marginBottom: 4 }}
          />
          <RecipeTextSections recipe={recipe} />
        </Box>
      </Flex>
      {/* Moved buttons outside fullscreen-content to make them fixed */}
      <Box
        fixed="bottom"
        padding={3}
        textAlign="center"
        className="fullscreen-buttons-container no-print"
      >
        <Button variant="secondary" onClick={onClose} title="Retour">
          Retour
        </Button>
        <Button marginStart={2} onClick={() => window.print()} title="Imprimer">
          Imprimer
        </Button>
      </Box>
    </Box>
  );
};

export default FullScreenRecipeView;
